import React from "react";
import Items from "./Items";
import { useSelector } from "react-redux";
const SaleItems = () => {
  const table_data = useSelector((state) => state.messageDetail);

  if (!table_data.table_data) return null;
  const joinedData = [
    ...table_data.table_data.dish,
    ...table_data.table_data.goods,
  ];

  return (
    <div className="sale_item_body">
      <h3 className="header_title">Sale Items</h3>
      <div className="sale_item_container">
        <ul className="sale_item_list">
          {joinedData.map((data) => {
            const { _id, discount, status, category } = data;
            return (
              <React.Fragment key={_id}>
                {(discount > 0 || discount === 100) &&
                  status === "Display" &&
                  category !== "dish" && <Items data={data} />}
              </React.Fragment>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default SaleItems;
